(function () {
    if (window.__tlShipInit) { window.__tlShipRun && window.__tlShipRun(); return; }
    window.__tlShipInit = true;
    var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var ZIP = { FR: '75001', BE: '1000', LU: '1111', CH: '8001', US: '10001' };
    var LOC = ((window.Shopify && window.Shopify.locale) || document.documentElement.lang || 'fr').toLowerCase();
    var EN = LOC.indexOf('en') === 0;
    var T = EN ? { free: 'Free', calc: 'Calculated at checkout' } : { free: 'Offerte', calc: 'Calculée au paiement' };
    var CUR = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    var fmt = function (cents) {
      return new Intl.NumberFormat(EN ? 'en-US' : 'fr-FR', { style: 'currency', currency: CUR }).format(cents / 100);
    };
    var busy = false, again = false, lastKey = '';
    function setText(el, v) { if (el.textContent !== v) el.textContent = v; }
    function country() {
      var c = (window.Shopify && window.Shopify.country) || 'FR';
      return ZIP[c] ? c : null;
    }
    async function getRates(cty) {
      var q = 'shipping_address%5Bcountry%5D=' + cty + '&shipping_address%5Bzip%5D=' + ZIP[cty];
      // Shopify exige un État pour les États-Unis, sinon la requête échoue en 422
      if (cty === 'US') q += '&shipping_address%5Bprovince%5D=New%20York';
      await fetch(ROOT + 'cart/prepare_shipping_rates.json?' + q, { method: 'POST' });
      for (var i = 0; i < 10; i++) {
        await new Promise(function (r) { setTimeout(r, 600); });
        var res = await fetch(ROOT + 'cart/async_shipping_rates.json?' + q);
        if (res.status === 200) { var j = await res.json(); return j.shipping_rates || []; }
      }
      return null;
    }
    async function run() {
      if (busy) { again = true; return; }
      var els = document.querySelectorAll('[data-tl-ship]');
      if (!els.length) return;
      busy = true;
      try {
        var cart = await (await fetch(ROOT + 'cart.js')).json();
        if (cart.currency) CUR = cart.currency;
        var cty = country();
        var key = cart.total_price + '|' + cart.item_count + '|' + cty;
        // Tarif connu du panier (chiffon) : l'API renvoie les tarifs dans la devise de la boutique, pas celle du client
        var fixe = document.querySelector('[data-tl-ship-fixed]');
        var rates = fixe ? null : !cty ? null : (window.__tlShipCache && lastKey === key ? window.__tlShipCache : await getRates(cty));
        lastKey = key; window.__tlShipCache = rates;
        var price = fixe ? parseInt(fixe.getAttribute('data-tl-ship-fixed'), 10) : null;
        if (!fixe && rates && rates.length) {
          price = Math.min.apply(null, rates.map(function (r) { return Math.round(parseFloat(r.price) * 100); }));
        }
        document.querySelectorAll('[data-tl-ship-value]').forEach(function (el) {
          setText(el, price === null ? T.calc : (price === 0 ? T.free : fmt(price)));
        });
        document.querySelectorAll('[data-tl-ship-hint]').forEach(function (el) { var h = !(price > 0); if (el.hidden !== h) el.hidden = h; });
        if (price !== null && price > 0) {
          document.querySelectorAll('.cart-totals__total-value').forEach(function (el) {
            setText(el, fmt(cart.total_price + price));
          });
        }
      } catch (e) {
        document.querySelectorAll('[data-tl-ship-value]').forEach(function (el) { setText(el, T.calc); });
      } finally {
        busy = false;
        if (again) { again = false; run(); }
      }
    }
    window.__tlShipRun = run;
    var t;
    var schedule = function () { clearTimeout(t); t = setTimeout(run, 150); };
    document.addEventListener('cart:update', schedule);
    new MutationObserver(function (m) {
      for (var i = 0; i < m.length; i++) {
        var tg = m[i].target.nodeType === 1 ? m[i].target : m[i].target.parentElement;
        if (tg && tg.closest && tg.closest('.cart-totals')) { schedule(); return; }
        for (var k = 0; k < m[i].addedNodes.length; k++) {
          var n = m[i].addedNodes[k];
          if (n.nodeType === 1 && (n.matches('[data-tl-ship]') || n.querySelector('[data-tl-ship]'))) { schedule(); return; }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  })();
